export default IconMusicX => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-music-x" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
  <path d="M9 17v-13h10v9" />
  <path d="M9 8h10" />
  <path d="M22 22l-5 -5" />
  <path d="M17 22l5 -5" />
</svg>`;